export default "__VITE_ASSET__BbmXQBVS__"